var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevelMenuIconSmOr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.251,
    height: 29.251,
    viewBox: "0 0 29.251 29.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "level-menu-icon-sm-or",
    transform: "translate(-29 -332.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-gas-pump",
    "data-name": "Icon awesome-gas-pump",
    d: "M19.2,25.595H.914A.917.917,0,0,0,0,26.509v1.828a.917.917,0,0,0,.914.914H19.2a.917.917,0,0,0,.914-.914V26.509A.917.917,0,0,0,19.2,25.595ZM28.177,6.13,23.549,1.5a.917.917,0,0,0-1.291,0l-.646.646a.917.917,0,0,0,0,1.291l2.154,2.154V9.141a3.194,3.194,0,0,0,2.742,3.154v9.187a1.371,1.371,0,0,1-2.742,0V19.653a5.028,5.028,0,0,0-5.028-5.028h-.457V3.656A3.66,3.66,0,0,0,14.625,0H5.485A3.66,3.66,0,0,0,1.828,3.656v20.11H18.282v-6.4h.457a2.285,2.285,0,0,1,2.285,2.285v1.588a4.284,4.284,0,0,0,3.685,4.336,4.125,4.125,0,0,0,4.542-4.1V8.718A3.663,3.663,0,0,0,28.177,6.13ZM14.625,10.969H5.485V3.656h9.141Z",
    transform: "translate(29 332.875)",
    fill: "#ff770e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelMenuIconSmOr);
export default __webpack_public_path__ + "static/media/level-menu-icon-sm-or.1b0f9d907ec70d4c53882fc866a2948e.svg";
export { ForwardRef as ReactComponent };